export default "__VITE_ASSET__DYlKL4Sr__"